import { addParamToURL } from "utils/url";
import { PRODUCT_PARAM } from "constants/query-params";
export const CONTACT_SALES_PRODUCT_DEFINITIONS = [
    {
        param: "work-management",
        text: "Work & project management",
        hubspotValues: [
            "Work & project management"
        ]
    },
    {
        param: "crm",
        text: "Sales & CRM",
        hubspotValues: [
            "Sales & CRM"
        ]
    },
    {
        param: "marketing",
        text: "Email marketing",
        hubspotValues: [
            "Email marketing"
        ]
    },
    {
        param: "dev",
        text: "Product management / Software development",
        hubspotValues: [
            "Product management",
            "Software development"
        ]
    },
    {
        param: "service",
        text: "Ticketing & service management",
        hubspotValues: [
            "Ticketing & service management"
        ]
    }
];
export const CONTACT_SALES_PRODUCT_OPTIONS = CONTACT_SALES_PRODUCT_DEFINITIONS.map((d)=>({
        value: d.param,
        text: d.text
    }));
export const PRODUCT_PARAM_TO_PRODUCT_QUESTION_VALUES = Object.fromEntries(CONTACT_SALES_PRODUCT_DEFINITIONS.map((d)=>[
        d.param,
        d.hubspotValues
    ]));
export const addProductParamToContactSalesUrl = (url, productParam)=>{
    if (!url || !productParam) {
        return url;
    }
    return addParamToURL(url, PRODUCT_PARAM, encodeURIComponent(productParam));
};
